module.exports = __webpack_public_path__ + "img/platform-B-2.fe4068d1.jpg";